module.exports = __webpack_public_path__ + "img/9788954646918.23d0b2b0.jpg";